var _rect, _mask, _path, _tspan, _mask2, _path2, _rect2, _circle, _tspan2, _mask3, _path3, _g, _tspan3, _rect3, _rect4, _tspan4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 260,
    viewBox: "0 0 411 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45554)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_45554)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10.1934,
    width: 370,
    height: 219,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_45554)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_45554",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.1934C20.5 12.8797 23.1863 10.1934 26.5 10.1934H384.5C387.814 10.1934 390.5 12.8797 390.5 16.1934V58.1934H20.5V16.1934Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.1934H390.5H20.5ZM390.5 59.1934H20.5V57.1934H390.5V59.1934ZM20.5 58.1934V10.1934V58.1934ZM390.5 10.1934V58.1934V10.1934Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_45554)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.9034
  }, "V\xC4LJ LAG")))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_1002_45554",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 58.1934,
    width: 370,
    height: 54,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 58.1934,
    width: 370,
    height: 54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 58.1934H390.5V111.193H20.5V58.1934Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 110.193H20.5V112.193H390.5V110.193Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-6-outside-2_1002_45554)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 71.1934,
    width: 27,
    height: 27,
    rx: 13.5,
    className: "button-background"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 84.6935,
    r: 5.4,
    className: "button-foreground"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 69.5,
    y: 89.1329
  }, "Herr"))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-3_1002_45554",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 112.193,
    width: 370,
    height: 54,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 112.193,
    width: 370,
    height: 54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 112.193H390.5V165.193H20.5V112.193Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 164.193H20.5V166.193H390.5V164.193Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-11-outside-3_1002_45554)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 125.193,
    width: 27,
    height: 27,
    rx: 13.5,
    className: "button-background"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 69.5,
    y: 143.133
  }, "Dam"))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1002_45554)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 175.193,
    width: 350,
    height: 40,
    rx: 6,
    className: "button-background",
    shapeRendering: "crispEdges"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 175.693,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "button-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 182.719,
    y: 198.333
  }, "AVBRYT"))))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.6934,
    width: 369,
    height: 218,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45554",
    x: 0.5,
    y: 0.193359,
    width: 410,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_45554",
    x: 10.5,
    y: 5.19336,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1002_45554",
    x: 10.5,
    y: 165.193,
    width: 390,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_45554"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10.1934,
    width: 370,
    height: 219,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubselect);
export default __webpack_public_path__ + "static/media/clubselect.da7c0527461f69ee6d3be0583441fa63.svg";
export { ForwardRef as ReactComponent };